// extracted by mini-css-extract-plugin
export var columnList = "_dd-0";